export default __webpack_public_path__ + "static/getappscreen-9972a0f91b499a87283488da90eabc0e.png";